import type { SendChatDialogMessageRequest } from '@/core/generated/api';
import type { ChatDialogSendMessageFormValues } from './model/types';

/** Подготавливает ответ пользователю */
export const chatDialogFormToSendRequest = (
    values: ChatDialogSendMessageFormValues,
    clientMessageId: string,
): SendChatDialogMessageRequest => ({
    clientMessageId,
    text: values.text,
    ...(values.photoUrls?.length
        ? { photoUrls: values.photoUrls }
        : {}),
});
